import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const StudentProfile = createAsyncThunk('student-profile', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/profile`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentPayments = createAsyncThunk('student-payments', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/payments`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSchedule = createAsyncThunk('get-schedule', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/get-schedule`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetSemesters = createAsyncThunk('get-semesters', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/get-semesters`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetMarkSheet = createAsyncThunk('get-mark-sheet', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/get-mark-sheet`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStudentClasses = createAsyncThunk('get-student-classes', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/get-student-classes`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAttendance = createAsyncThunk('student-attendance', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dphs-student/get-attendance`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const studentFeeStatistic = createAsyncThunk('student-payments-student-fee-statistic', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/student-fee-statistic`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const studentTransportStatistic = createAsyncThunk('student-payments-student-transport-statistic', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/student-transport-statistic`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const studentBookStatistic = createAsyncThunk('student-payments-student-book-statistic', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/student-book-statistic`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const studentUniformStatistic = createAsyncThunk('student-payments-student-uniform-statistic', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/student-uniform-statistic`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentTransportPayments = createAsyncThunk('student-transport-payments', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dphs-student/transport-payments`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type studentPortalState = {
  errors: any
}

const initialState: studentPortalState = {
  errors: '',
}

export const StudentPortalSlice = createSlice({
  name: 'student-portal',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
  },
})

export const { reset } = StudentPortalSlice.actions
export default StudentPortalSlice.reducer
